// Visuell rendering av ButtonBlock i canvas. Matchar bulletproof-button-mönstret
// från serialize.ts — anchortag styled som knapp.

import { Box } from '@mui/material';
import { useBlockCanvas } from '../canvasContext';
import { ButtonBlock, DEFAULT_FONT_STACK } from '../types';

type Props = { block: ButtonBlock };

export const ButtonBlockView = ({ block }: Props) => {
  const ctx = useBlockCanvas();
  const fontFamily = ctx?.docSettings.bodyFontFamily ?? DEFAULT_FONT_STACK;
  const bg = block.bgColor ?? '#222222';
  const fg = block.textColor ?? '#ffffff';
  return (
    <Box sx={{ p: '16px 30px', textAlign: block.align }}>
      <Box
        component='a'
        href={block.href}
        target='_blank'
        rel='noopener noreferrer'
        sx={{
          display: 'inline-block',
          padding: '12px 28px',
          backgroundColor: bg,
          color: fg,
          fontFamily,
          fontSize: '15px',
          fontWeight: 600,
          textDecoration: 'none',
          borderRadius: '4px',
        }}
      >
        {block.label}
      </Box>
    </Box>
  );
};

export default ButtonBlockView;
